import { createApi } from '@reduxjs/toolkit/query/react';

import { apiDexBase } from '~constants/api';
import { rtkBaseQueryWrapper, unwrap } from '~libs/axiosWrapper';
import {
  DexCopyBulkParams,
  DexCopyParams,
  DexCopyResult,
  DexPreviewParams,
  DexPreviewResult,
  DexReadinessParams,
  DexReadinessResult,
} from '~dex/types';

export const dexApi = createApi({
  reducerPath: 'dexApi',
  baseQuery: rtkBaseQueryWrapper({ baseUrl: apiDexBase }),
  tagTypes: ['DexReadiness'],
  endpoints: (builder) => ({
    getDexPreview: builder.query<DexPreviewResult, DexPreviewParams>({
      query: (params) => ({ url: '/export/preview', method: 'GET', params }),
      transformResponse: (payload) => unwrap<DexPreviewResult>(payload),
    }),
    getDexReadiness: builder.query<DexReadinessResult, DexReadinessParams>({
      query: (params) => ({ url: '/readiness', method: 'GET', params }),
      transformResponse: (payload) => unwrap<DexReadinessResult>(payload),
      providesTags: ['DexReadiness'],
    }),
    // TAV-3133: invalidating the DexReadiness tag automatically refetches the currently-mounted
    // lazy readiness query (DexReadinessPage), so a successful copy is reflected without any
    // manual refetch wiring.
    copyDexData: builder.mutation<DexCopyResult, DexCopyParams>({
      query: (body) => ({ url: '/copy', method: 'POST', body }),
      transformResponse: (payload) => unwrap<DexCopyResult>(payload),
      invalidatesTags: ['DexReadiness'],
    }),
    copyDexDataBulk: builder.mutation<DexCopyResult, DexCopyBulkParams>({
      query: (body) => ({ url: '/copy-bulk', method: 'POST', body }),
      transformResponse: (payload) => unwrap<DexCopyResult>(payload),
      invalidatesTags: ['DexReadiness'],
    }),
  }),
});

export const {
  useLazyGetDexPreviewQuery,
  useLazyGetDexReadinessQuery,
  useCopyDexDataMutation,
  useCopyDexDataBulkMutation,
} = dexApi;
